<template>
  <div>
    <div v-if="row.info && row.info.date_start && row.info.date_end">
      {{ row.info.date_start }} - {{ row.info.date_end }}
    </div>
  </div>
</template>

<script>
export default {
  name: "bonus-period-column-template",
  components: {},
  props: {
    row: {type: Object, required: true}
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style>

</style>